import { FelaCSS } from '@bridebook/ui';

interface IStyleProps {
  isLoggedIn?: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
  addressTitle: FelaCSS;
  copyToClipboardButton: FelaCSS;
  mapWrap: FelaCSS;
  showDirectionsLink: FelaCSS;
  contactDetailsWrap: FelaCSS;
  socialWrap: FelaCSS;
  contactWrap: FelaCSS;
}

const styles = ({ isLoggedIn }: IStyleProps): IStyles => ({
  wrapper: {
    marginTop: isLoggedIn ? 4 : 0,
    paddingTop: isLoggedIn ? 0 : 4,
  },
  addressTitle: {
    fontDefaultSemiBold: 16,
    marginBottom: 2,
    marginTop: 3,
  },
  copyToClipboardButton: {
    paddingLeft: 2,
  },
  mapWrap: {
    paddingVertical: 6,
    desktopDesign: {
      paddingTop: 0,
    },
  },
  showDirectionsLink: {
    textDecoration: 'underline',
  },
  contactDetailsWrap: {
    marginBottom: 6,
  },
  socialWrap: {
    paddingTop: 8,
  },
  contactWrap: {
    width: '343px',
    alignSelf: 'center',
    alignItems: 'center',
    paddingTop: 6,

    maxWidthTabletSm: {
      width: '100%',
    },
  },
});

export default styles;
